export default {
  labels: {
    question: 'Question',
    answer: 'Answer',
    category: 'Category Name',
    categoryIcon: 'Icon',
    file: 'Upload File',
    categories: 'Categories',
  },
  titles: {
    categories: 'Categories',
    FAQs: 'FAQs',
    T_C: 'Terms And Conditions',
    FAQ: 'FAQ',
  },
  descriptions: {
    addFAQ: 'Add New FAQ',
    editFAQ: 'Update FAQ',
    addCategory: 'Add New Category',
    editCategory: 'Update Category',
    uploadT_C: 'Upload New Terms and Condition',
    editT_C: 'Update Terms and Condition',
  },
  submitMessages: {
    addFAQ: 'A New FAQ Added Successfully.',
    editFAQ: 'FAQ Updated Successfully.',
    addCategory: 'A New Category Added Successfully.',
    editCategory: 'Category Updated Successfully.',
    uploadT_C: 'New Term and Condition Uploaded Successfully.',
    editT_C: 'Term and Condition Updated Successfully.',
  },
  placeholders: {
    enterQuestion: 'Enter Question',
    enterAnswer: 'Enter Answer',
    enterCategory: 'Enter Category Name',
    selectCategory: 'Select One Category',
  },
};
